import { Component, Input } from '@angular/core';

@Component({
	selector: 'project-team-joins',
	template: require('./project.team.joins.component.html'),
})
export class ProjectTeamJoinsComponent {

	@Input() parentCtrl: any = null;

	constructor(
	) { }
}